var _defs, _clipPath, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    strokeMiterlimit: 10,
    style: {
      fillRule: "nonzero",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    viewBox: "0 0 200 256",
    width: "100%",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "ArtboardFrame"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 256,
    width: 200,
    x: 0,
    y: 0
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ArtboardFrame)",
    id: "Untitled"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M182.684 34.56C155.324 29.568 132.491 19.712 112.888 4.43733C105.296-1.47911 94.6958-1.47911 87.1095 4.43733C67.5001 19.7148 44.6675 29.568 17.3102 34.5628C7.27731 36.3947 2.13163e-14 45.1641 0 55.4155L2.13163e-14 141.628C1.42109e-14 191.784 35.7997 236.123 91.2088 254.583C94.0438 255.528 97.0205 256 100 256C102.98 256 105.956 255.528 108.791 254.583C164.197 236.123 200 191.784 200 141.628L200 55.4126C199.994 45.1612 192.714 36.3918 182.684 34.56Z",
    fill: "currentColor",
    fillRule: "nonzero",
    opacity: 1,
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.3619e21176e074c53e32777e9c04ed47.svg";
export { ForwardRef as ReactComponent };